import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountJournal } from "src/models/Accounting/Accounting.models";

interface JournalState {
  journals: IAccountJournal[];
  journalToEdit: IAccountJournal | null;
}

const initialState: JournalState = {
  journals: [],
  journalToEdit: null,
};

const journalSlice = createSlice({
  name: "Journal",
  initialState,
  reducers: {
    setJournalList: (
      state,
      action: PayloadAction<IAccountJournal[]>
    ) => {
      state.journals = action.payload;
    },
    concatListJournal: (
      state: JournalState,
      action: PayloadAction<IAccountJournal[]>
    ) => {
      state.journals = [
        ...state.journals.concat(action.payload),
      ];
    },
    setJournalToEdit: (
      state,
      action: PayloadAction<IAccountJournal | null>
    ) => {
      state.journalToEdit = action.payload;
    },
    addJournal: (state, action: PayloadAction<IAccountJournal>) => {
      state.journals.push(action.payload);
    },
    updateJournal: (
      state,
      action: PayloadAction<IAccountJournal>
    ) => {
      let itemIndex = state.journals.findIndex(
        item => item.accountJournalId === action.payload.accountJournalId
      );
      if (itemIndex !== -1) state.journals[itemIndex] = action.payload;
    },
    deleteJournal: (state, action: PayloadAction<number>) => {
      const newArray = state.journals.filter(
        item => item.accountJournalId !== action.payload
      );
      state.journals = newArray;
    },
  },
});

export const {
  setJournalList,
  concatListJournal,
  setJournalToEdit,
  addJournal,
  updateJournal,
  deleteJournal,
} = journalSlice.actions;

export default journalSlice.reducer;
